// Shared by WhatsAppBulkSendModal (Plans), WhatsAppCampaignsPage, and WhatsAppTemplatesPage's
// own preview — one place for the {{1}}, {{2}}... placeholder logic instead of drifting copies.

export function findBodyComponent(template) {
  return (template?.components || []).find((c) => c.type === "body" || c.type === "BODY");
}

// "hello_world" is Meta's fixed, auto-provisioned demo template — it exists on every
// WABA (including production ones, since "Sync from Meta" pulls it in same as any other
// approved template), but Meta hard-blocks sending it from anywhere except their own free
// test number (error #131058: "Hello World templates can only be sent from the Public
// Test Numbers"), even though nothing in its own status/category says so. Never a
// legitimate template to actually send to a creator either way, so it's excluded from
// every send picker rather than trying to detect "is this a test number" some other way.
export function isSendableTemplate(template) {
  return template?.name !== "hello_world";
}

// Counts the distinct {{1}}, {{2}}... placeholders in a template's body text, so a compose
// form only asks for exactly the variables the template actually needs.
export function countBodyVariables(template) {
  const body = findBodyComponent(template);
  if (!body?.text) return 0;
  const matches = body.text.match(/\{\{\s*\d+\s*\}\}/g);
  return matches ? new Set(matches).size : 0;
}

export function bodyPreview(template, variables) {
  const body = findBodyComponent(template);
  if (!body?.text) return "";
  return body.text.replace(/\{\{\s*(\d+)\s*\}\}/g, (_, n) => variables[Number(n) - 1] || `{{${n}}}`);
}

// Reconstructs the builder's flat form shape (headerType/headerText/bodyText/bodySamples/
// footerText/buttons) from a template's raw Meta-shaped `components` array — the reverse
// of TemplateBuilderDialog's buildComponents(). Shared by the builder (edit mode) and the
// read-only preview dialog so both parse the exact same way.
export function parseComponents(components) {
  const find = (type) => (components || []).find((c) => (c.type || "").toUpperCase() === type);
  const header = find("HEADER");
  const body = find("BODY");
  const footer = find("FOOTER");
  const buttonsComp = find("BUTTONS");

  const bodyText = body?.text || "";
  const bodyVarMatches = bodyText.match(/\{\{\s*\d+\s*\}\}/g);
  const bodyVarCount = bodyVarMatches ? new Set(bodyVarMatches).size : 0;
  const bodySamples = body?.example?.body_text?.[0] || new Array(bodyVarCount).fill("");

  return {
    headerType: header?.format || "NONE",
    headerText: header?.format === "TEXT" ? header.text || "" : "",
    bodyText,
    bodySamples,
    footerText: footer?.text || "",
    buttons: (buttonsComp?.buttons || []).map((b) => ({
      type: b.type,
      text: b.text || "",
      url: b.url || "",
      phoneNumber: b.phone_number || "",
    })),
  };
}
